import { jsx as _jsx } from "react/jsx-runtime";
const LoadingScreen = ({ loadingMessage = "Loading your info..." }) => {
    return (_jsx("div", { id: "tw-root", children: _jsx("div", { id: "tw-main", className: "App container text-center", children: _jsx("h3", { className: "text-center w-full my-4 animate-pulse", children: loadingMessage }) }) }));
};
export default LoadingScreen;
